import styles from './card.module.scss'

interface CardProps { 
  children?: React.ReactNode;
  padding?: string;
  background?: string;
}
const Card: React.FC<CardProps> = (props) => { 
  return (
    <div style={{padding: props.padding ?? '', background: props.background}} className={styles.card}>
      {props.children}
    </div>
  )
}

export default Card